import { MicrophoneIcon } from "./icons";
import { Button } from "antd";
import { CSSProperties, MouseEventHandler } from "react";

export const MicrophoneButton = ({
  fillColor = "#fff",
  onClick,
  style,
  iconStyle,
}: {
  fillColor: CSSProperties["color"];
  onClick?: MouseEventHandler<HTMLButtonElement>;
  style?: CSSProperties;
  iconStyle?: CSSProperties;
}) => (
  <Button
    type="text"
    style={{
      ...style,
      background: "transparent",
    }}
    onClick={onClick}
    icon={<MicrophoneIcon style={iconStyle} fillColor={fillColor} />}
  />
);
